<h4 style="font-weight: bold; margin-top: 0px">{{ modalTitle || 'Media Only' }}</h4>
<div *ngIf="catalogInformation && catalogInformation.length > 0">
  <div class="grid">
    <div class="col">
      <div class="flex align-content-center flex-nowrap">
        <div class="flex align-items-center justify-content-center mr-2">
          <p-floatlabel variant="on">
            <p-inputnumber
              [(ngModel)]="orderSubstrate.quantity"
              (ngModelChange)="computeSubstrateValidation(false)"
              [useGrouping]="false"
              class="width-6 required"
              inputId="quantity"
              data-testid="quantity"
              aria-labelledby="quantityLabel"
              allowNumbersOnly />
            <label id="quantityLabel" for="quantity">Quantity</label>
          </p-floatlabel>
        </div>
        <div class="flex align-items-center justify-content-center flex-grow-1">
          <p-floatlabel variant="on" class="w-full">
            <p-select
              #containerSelect
              appLockInitialWidth
              [options]="filteredContainers"
              [(ngModel)]="orderSubstrate.container"
              data-testid="substrateContainer"
              optionLabel="text"
              optionValue="id"
              filter="true"
              filterPlaceholder="Search Container"
              class="required"
              fluid="true"
              [disabled]="editingInstance"
              appendTo="body"
              (onChange)="onContainerChange($event.value)">
            </p-select>
            <label for="on_label">Container</label>
          </p-floatlabel>
        </div>
      </div>
    </div>
  </div>
  <div class="grid">
    <div class="col">
      <app-substrate-item
        [catalogInformation]="catalogInformation"
        [filteredSubstrates]="filteredSubstrates"
        [units]="units"
        [editingOrderItemSubstrate]="editingOrderItemSubstrate"
        [selectedContainerId]="orderSubstrate.container"
        [editingInstance]="editingInstance"
        [editingMode]="editingMode"
        [selectedContainerTypeName]="getSelectedContainerTypeName()"
        (substrateItemChangeEvent)="onReceiveSubstrateData($event)">
      </app-substrate-item>
    </div>
  </div>
  <div class="grid mt-1px">
    <div class="col-12">
      <p-floatlabel variant="on" class="w-full">
        <p-treeselect
          [options]="locationNodes"
          [(ngModel)]="selectedLocationNode"
          data-testid="substrateLocation"
          containerStyleClass="w-full"
          class="required"
          appendTo="body"
          (onNodeSelect)="onLocationNodeSelect($event)">
        </p-treeselect>
        <label for="on_label">Delivery Location</label>
      </p-floatlabel>
    </div>
  </div>
  <div class="grid mt-1px" *ngIf="!editingInstance">
    <div class="col-12">
      <p-floatlabel variant="on">
        <p-select
          #projectSelect
          appLockInitialWidth
          [options]="projects"
          [(ngModel)]="orderSubstrate.projectId"
          fluid="true"
          data-testid="project"
          optionLabel="ProjectName"
          optionValue="ProjectId"
          filter="true"
          pTooltip="{{ projectTooltipText }}"
          tooltipPosition="right"
          tooltipStyleClass="custom-tooltip"
          filterPlaceholder="Search Project"
          appendTo="body"></p-select>
        <label for="on_label">Project</label>
      </p-floatlabel>
    </div>
  </div>
  <div class="grid mt-1px" *ngIf="!editingInstance || (editingInstance && editingMode === 'single')">
    <div class="col">
      <div class="flex align-content-center flex-wrap">
        <div class="flex align-items-center justify-content-center mr-2">
          <p-floatlabel variant="on">
            <p-datepicker
              class="required"
              id="deliveryDate"
              [(ngModel)]="orderSubstrate.deliveryDate"
              [minDate]="minDate"
              [maxDate]="maxDate"
              showIcon
              iconDisplay="input"
              data-testId="deliveryDate"
              appendTo="body"
              [disabledDates]="unavailableDates"
              [disabledDays]="invalidDays"
              [disabled]="
                !substrateSelected ||
                (!editingInstance && selectedDates && selectedDates.length > 1) ||
                (editingInstance && editingMode === 'future' && selectedDates && selectedDates.length > 1)
              "
              (onSelect)="onDeliveryDateChange()"
              (onInput)="onDeliveryDateChange()"></p-datepicker>
            <label for="on_label">Delivery Date</label>
          </p-floatlabel>
        </div>
        <div *ngIf="showRecurringDatesTooltip" class="flex align-items-center justify-content-center">
          <span
            class="pi pi-info-circle mr-1"
            pTooltip="{{ recurringDatesTooltip }}"
            tooltipPosition="top"
            tooltipStyleClass="custom-tooltip"
            style="font-size: 1.2em; cursor: pointer">
          </span>
        </div>
        <div *ngIf="showMakeRecurringButton" class="flex align-items-center justify-content-center">
          <p-button
            [label]="status === 'Updated' || status === 'Approved' ? 'Reschedule Recurrences' : 'Make Recurring'"
            icon="pi pi-sync"
            severity="primary"
            [raised]="true"
            (click)="openMakeRecurringDialog()"
            data-testid="makeRecurring"
            [disabled]="!substrateSelected" />
        </div>
      </div>
    </div>
  </div>
  <div class="grid mt-1px">
    <div class="col">
      <p-floatlabel variant="on">
        <textarea pTextarea data-testid="note" [(ngModel)]="orderSubstrate.note" rows="12" style="resize: none" class="w-full h-full"></textarea>
        <label for="on_label">Notes</label>
      </p-floatlabel>
    </div>
  </div>
  <div class="border-top-1 surface-border pt-2 flex justify-content-between w-full">
    <p-button label="Cancel" icon="fa fa-times" severity="danger" size="small" [raised]="true" (click)="onCancel()" data-testid="newItemCancel" />
    <p-button
      *ngIf="showAddButton"
      label="Add"
      icon="fa fa-check"
      severity="success"
      size="small"
      [raised]="true"
      (click)="onSaveOrderItem()"
      data-testid="newItemSave"
      [disabled]="!isSubstrateFormValid" />
    <p-button
      *ngIf="!showAddButton"
      label="Save"
      icon="fa fa-check"
      severity="success"
      size="small"
      [raised]="true"
      (click)="onEditSaveOrderItem()"
      data-testid="newItemSave"
      [disabled]="!isSubstrateFormValid" />
  </div>
</div>

<p-dialog
  [modal]="true"
  [showHeader]="true"
  [position]="'center'"
  [closeOnEscape]="false"
  [closable]="false"
  [(visible)]="showRecurringDialog"
  appendTo="body"
  (onHide)="showRecurringDialog = false"
  (onShow)="onDialogShow()"
  [style]="{ 'width': '70vw' }">
  <ng-template #header>
    <h4><strong>Build Recurrence Schedule</strong></h4>
  </ng-template>
  <div class="grid">
    <div class="col-4">
      <app-recurrence-schedule
        #recurrenceComp
        [minDate]="minDate"
        [maxDate]="maxDate"
        [invalidDays]="invalidDays"
        [invalidDates]="unavailableDates"
        [invalidDatesStr]="unavailableDatesIsoStrings"
        [firstDeliveryDate]="firstDeliveryDate"
        [invalidRecurrenceDates]="invalidRecurringDates"
        [recurrenceSchedule]="recurrenceSchedule"
        (updateRecurrences)="updateRecurrences($event)"></app-recurrence-schedule>
    </div>
    <div class="col-8">
      <app-calendar
        #calendarComp
        [minDate]="minDate"
        [maxDate]="maxDate"
        [invalidDays]="invalidDays"
        [invalidDates]="unavailableDatesIsoStrings"
        [selectedDates]="selectedDates"
        [invalidRecurrenceDates]="invalidRecurringDates"
        (updateRecurrences)="updateRecurrences($event)"></app-calendar>
    </div>
  </div>
  <ng-template #footer>
    <div
      class="border-top-1 surface-border pt-2 flex justify-content-end flex-wrap w-full"
      *ngIf="editingInstance && (status === 'Updated' || status === 'Approved')">
      <div class="flex flex-wrap">
        <div class="flex align-items-center justify-content-center mr-1">
          <p-button
            label="Cancel"
            icon="fa fa-cancel"
            severity="danger"
            size="small"
            [raised]="true"
            data-testid="cancelRecurrences"
            (click)="cancelRecurrences()" />
        </div>
        <div class="flex align-items-center justify-content-center">
          <p-button
            label="Save Recurrences"
            icon="fa fa-check"
            severity="success"
            size="small"
            [raised]="true"
            data-testid="addRecurrences"
            (click)="addRecurrences()" />
        </div>
      </div>
    </div>
    <div
      class="border-top-1 surface-border pt-2 flex justify-content-between flex-wrap w-full"
      *ngIf="!editingInstance || (editingInstance && status !== 'Updated' && status !== 'Approved')">
      <div class="flex align-items-center justify-content-center">
        <p-button
          label="Remove Recurrences"
          icon="fa fa-times"
          severity="danger"
          size="small"
          [raised]="true"
          data-testid="removeRecurrences"
          (click)="removeRecurrences()" />
      </div>
      <div class="flex flex-wrap">
        <div class="flex align-items-center justify-content-center mr-1">
          <p-button
            label="Cancel"
            icon="fa fa-cancel"
            severity="danger"
            size="small"
            [raised]="true"
            data-testid="cancelRecurrences"
            (click)="cancelRecurrences()" />
        </div>
        <div class="flex align-items-center justify-content-center">
          <p-button
            label="Save Recurrences"
            icon="fa fa-check"
            severity="success"
            size="small"
            [raised]="true"
            data-testid="addRecurrences"
            (click)="addRecurrences()" />
        </div>
      </div>
    </div>
  </ng-template>
</p-dialog>

<app-processing [visible]="isProcessing"></app-processing>
